
export const PASSWORD_HIDE_ICON = require('../../assets/icons/hide.svg');
export const PASSWORD_EYE = require('../../assets/icons/eye.svg');
export const HAMBURGER_ICON = require(`../../assets/icons/hamburger_icon.svg`);
export const TABLE_ARROW_DOWN = require(`../../assets/icons/arrow-down.svg`);
export const EDIT_ICON = require(`../../assets/icons/edit.svg`);
export const DELETE_ICON = require(`../../assets/icons/delete.svg`);
export const SEARCH_ICON = require(`../../assets/icons/search_icon.svg`);
export const LOGO_ICON = require(`../../assets/icons/logo.png`);